<template>
  <div class="mb-4">
    <p class="text-h6 mb-0">
      {{ $t('Preview') }}

      <v-chip
        class="ml-2"
        color="primary"
        label
        small
      >
        {{ previewOf }}
      </v-chip>
    </p>
    <p
      v-if="subtitle"
      class="subtitle-1"
    >
      {{ subtitle }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    previewOf: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false,
      default: null
    }
  }
}
</script>